import { render, staticRenderFns } from "./DialogPeople-comp.vue?vue&type=template&id=cb31b9e4&scoped=true&"
import script from "./DialogPeople-comp.vue?vue&type=script&lang=js&"
export * from "./DialogPeople-comp.vue?vue&type=script&lang=js&"
import style0 from "./DialogPeople-comp.vue?vue&type=style&index=0&id=cb31b9e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb31b9e4",
  null
  
)

export default component.exports